
    import { Options, Vue  } from "vue-class-component"; 
    import ConfiguracaoService from   "@/service/v10/sigap/ConfiguracaoService"  


    @Options({
        name: "Sobre",
        components: { },  
    }) 
    export default class Sobre extends Vue {
       
        public configuracaoService = new ConfiguracaoService(); 
        public comandante: any = null

        created(){ 
            this.buscaComandante();
        }

        public buscaComandante(){   
           
            this.configuracaoService.getModelByChave( 'comandante_apm'  ) 
            .then(response => {   
                this.comandante =  JSON.parse(JSON.stringify( response ));   
                 
            })
            .catch(error => { 
                console.log(error); 
            }); 
        } 

    } 
 
